import React from 'react'
import Header from '../Layout/Header'
import '@fortawesome/fontawesome-free/css/all.min.css';


function Earn() {
  return (
    <div>
          <Header/>
    <div className='earn'>
         <div class="container-fluid mt-5">
        <div class="row pt-5 ">
            <div class="mt-3">
                <button class="btn d-flex w-100 justify-content-center align-items-center main-1-btn-bg rounded-3 ">
                    <div><img class="w-50" src="img/icons8-magnetic-card-50.png" alt=""/></div>
                    <span class="text-dark" >Deposit </span>
                </button>
            </div>
        </div>


        <div class="row mt-5 pt-4">
            <div>
                {/* <div class="d-flex justify-content-center">
                    <img class="" src="img/come.png" alt=""/>
                </div>

                <h4 class="fw-bold text-center mt-4">Coming Soon</h4> */}
                <p class="text-muted text-center"><small>More profit opportunities.</small></p>
            </div>
        </div>
    </div>
    </div>
    <div style={{ height: "100px" }}></div>
    </div>
  )
}

export default Earn